<template>
    <front-layout>
        <Head>
            <title>{{post.title}}</title>
            <meta head-key="description" name="description" :content="post.excerto" />
        </Head>
        <div class="pt-40">
            <div v-if="post.image">
                <img :src="'/storage/posts/' + post.image" alt="imagem categoria" class=" w-full h-[36vh] object-cover">
            </div>
            <div class="w-2/3 mx-auto pb-4 px-4 my-20">
                <h1 class="text-3xl font-bold">{{ post.title }}</h1>
                <p class="text-xs text-gray-500">{{ dateFormated(post.created_at) }}</p>
                <p v-html="post.body" class="mt-8 text-lg"></p>
            </div>
        </div>
    </front-layout>
</template>


<script>
    import { defineComponent } from 'vue'
    import FrontLayout from '@/Layouts/FrontLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import Icon from '@/Jetstream/Icon.vue'

    export default defineComponent({
        components: {
            Head,
            Link,
            FrontLayout,
            Icon
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            categories: Array,
            post: Object
        },
        mounted(){
            console.log(this.post)
        },
        data() {
            return {
            }
        },
        methods: {
            dateFormated(jobDate) {
                let date = new Date(jobDate)
                return date.toLocaleDateString()
            },
        },
    })
</script>